import { StategyBadge } from 'components/PositionListItem/styled'
import { StakingTokenType } from 'types/farms'

import * as S from '../../../Liquidity.styles'

interface FarmTypeDisplayProps {
  type: StakingTokenType
}

export function FarmTypeDisplay({ type }: FarmTypeDisplayProps) {
  return (
    <S.FlexRow>
      <StategyBadge>
        {type === StakingTokenType.V2
          ? 'V2'
          : type === StakingTokenType.ISLAND
          ? 'Island'
          : type === StakingTokenType.GENERIC
          ? 'Generic'
          : 'Unknown'}
      </StategyBadge>
    </S.FlexRow>
  )
}
